/**
 * 清 SW / Cache Storage 后带 cache-bust 硬跳转。
 * 用于浏览器或主屏快捷方式卡在旧资源、普通刷新无效时。
 */
export async function hardReloadForUpdate(reason = 'update') {
	console.log('[updater] hard reload:', reason)
	try {
		if ('serviceWorker' in navigator) {
			const regs = await navigator.serviceWorker.getRegistrations()
			await Promise.all(regs.map((r) => r.unregister()))
		}
		if (typeof caches !== 'undefined') {
			const keys = await caches.keys()
			await Promise.all(keys.map((k) => caches.delete(k)))
		}
	} catch (e) {
		console.warn('[updater] hard reload cleanup failed', e)
	}
	const url = new URL(window.location.href)
	url.searchParams.set('_v', String(Date.now()))
	window.location.replace(url.toString())
}

/** 手动强制刷新：卸 SW、清 Cache、硬跳转。 */
export function forceAppUpdate() {
	return hardReloadForUpdate('manual')
}
